import React from "react";
import {
  Button,
  Flex,
  Text,
  Box,
  useToast,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  CheckboxGroup,
  Checkbox,
  Select,
  Textarea,
} from "@chakra-ui/core";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import useAuth from "../../../context/AuthContext";
import { getUserProfile, updateProfile } from "../../../api/user.service";
import { getJobCertifications, getJobSectors } from "../../../api/jobs.service";
import { citiesRegions } from "../../../lib/utils/mock";

const ProfileEditPage = () => {
  const { state } = useLocation();
  const [profile, setUserProfile] = React.useState(state);
  const history = useHistory();

  const userSpokenLanguages =
    profile.profile.languages && JSON.parse(profile.profile.languages);

  const [languages, setLanguages] = React.useState(userSpokenLanguages);
  const [jobCertifications, setJobCertifications] = React.useState([]);

  const [jobSectors, setJobSectors] = React.useState([]);
  const [region, setRegion] = React.useState(profile.profile.region);
  const [districts, setDistrict] = React.useState(
    citiesRegions[profile?.profile?.region] || []
  );
  const [district, setSelectedDistrict] = React.useState(profile.profile.city);
  const { register, handleSubmit, errors, formState } = useForm();
  const toast = useToast();

  const {
    state: { user },
  } = useAuth();

  const langOptions = ["Twi", "Nzemaa", "French", "Fantse", "English"];

  const regions = Object.keys(citiesRegions).map((key) => {
    return {
      label: key,
      value: key,
    };
  });

  const handleSelectRegion = (value) => {
    setRegion(value);
    checkDistrict(value);
  };

  const checkDistrict = (value) => {
    switch (value) {
      case value:
        setDistrict(citiesRegions[value]);
        break;
      default:
        break;
    }
  };

  const onSubmit = async (values) => {
    try {
      console.log(values);
      const { data } = await updateProfile({ ...values, languages });

      history.push("/dashboard/me");
      toast({
        title: "Profile Update",
        description: "You have successfully updated your profile",
        position: "top",
        duration: 2500,
      });
    } catch (error) {
      toast({
        title: "Profile Update",
        description: "Profile update failed. Please try again",
        position: "top",
        duration: 2500,
        status: "error",
      });
    }
  };

  const getDate = (date) => {
    let currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate());
    const parsedDate = currentDate.toISOString().substr(0, 10);

    return parsedDate;
  };

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await getUserProfile();
        data && setUserProfile(data);
      } catch (error) {
        console.log("err", error);
      }
    };

    const fetchJobCertifications = async () => {
      try {
        const { data } = await getJobCertifications();

        const transformedJobCertifications =
          data &&
          data.data?.map((jobCertification) => {
            return {
              job_certification_id: jobCertification.id,
              job_certification: jobCertification.name,
            };
          });

        setJobCertifications(transformedJobCertifications);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchJobSectors = async () => {
      try {
        const { data } = await getJobSectors();

        const transformedJobSectors =
          data &&
          data.data?.map((jobSector) => {
            return {
              job_sector_id: jobSector.id,
              job_sector: jobSector.name,
            };
          });

        setJobSectors(transformedJobSectors);
      } catch (error) {
        console.log(error);
      }
    };

    fetchUserProfile();
    fetchJobCertifications();
    fetchJobSectors();
  }, []);

  return (
    <Box height='100%' w='100%' pb='40' mb='40'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          flex='1'
          w='100%'
        >
          <Text
            fontWeight='700'
            textAlign='center'
            fontSize='xl'
            my={["2", "8"]}
          >
            Edit Profile
          </Text>
          <Flex
            direction='column'
            width='100%'
            height={["auto", "80%"]}
            boxShadow='md'
            border='1px solid #EDF2F7'
            p={["0", "4"]}
          >
            <Box
              display='flex'
              flexDirection={["column", "nationalityrow"]}
              rounded='10px'
            >
              <Box flex='1' m='10px'>
                <Flex w='100%'>
                  <FormControl mt='15px' w='50%'>
                    <FormLabel htmlFor='first_name'>First name</FormLabel>
                    <Input
                      defaultValue={profile.first_name}
                      placeholder='First name'
                      name='firstName'
                    />
                  </FormControl>
                  <FormControl w='50%' mt='15px'>
                    <FormLabel htmlFor='last_name'>Last name</FormLabel>
                    <Input name='last_name' defaultValue={profile.last_name} />
                  </FormControl>
                </Flex>
                <FormControl
                  mt='20px'
                  isInvalid={errors.about}
                  flex='1'
                  w='100%'
                >
                  <FormLabel htmlFor='about'>About</FormLabel>
                  <Textarea
                    type='text'
                    placeholder='Tell us about yourself'
                    name='about'
                    ref={register}
                    defaultValue={profile.profile.about}
                  ></Textarea>
                  <FormErrorMessage>
                    {errors.about && errors.about.message}
                  </FormErrorMessage>
                </FormControl>
                <Flex w='100%'>
                  <FormControl w='50%' isDisabled mt='20px'>
                    <FormLabel htmlFor='email'>Email</FormLabel>
                    <Input
                      id='email'
                      placeholder='Email'
                      name='email'
                      defaultValue={profile.email}
                    />
                  </FormControl>
                  <FormControl w='50%' flex='1' mt='20px' isRequired>
                    <FormLabel
                      htmlFor='nationality'
                      isInvalid={errors.nationality}
                    >
                      Nationality
                    </FormLabel>
                    <Input
                      type='text'
                      name='nationality'
                      ref={register}
                      defaultValue={profile.profile.nationality}
                    ></Input>
                    <FormErrorMessage>
                      {errors.nationality && errors.nationality.message}
                    </FormErrorMessage>
                  </FormControl>
                </Flex>
                <Flex mt='4'>
                  <FormControl w='50%'>
                    <FormLabel>Job Sector</FormLabel>
                    <Select
                      // placeholder={job.job_sector?.name}
                      ref={register}
                      name='job_sector_id'
                    >
                      {jobSectors.map((sector) => (
                        <option
                          value={sector.job_sector_id}
                          key={sector.job_sector_id}
                          selected={
                            profile.profile?.job_sector?.id ===
                            sector.job_sector_id
                          }
                        >
                          {sector.job_sector}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl w='50%'>
                    <FormLabel>Certification Required</FormLabel>
                    <Select
                      // placeholder='Select Job Certifcation'
                      ref={register}
                      name='job_certification_id'
                      defaultValue={profile.profile?.job_certification?.id}
                    >
                      {jobCertifications.map((certifications) => (
                        <option
                          value={certifications.job_certification_id}
                          key={certifications.job_certification_id}
                          selected={
                            profile.profile?.job_certification?.id ===
                            certifications.job_certification_id
                          }
                        >
                          {certifications.job_certification}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </Flex>
                <Flex w='100%'>
                  <FormControl w='50%' mt='20px' flex='1' isRequired>
                    <FormLabel htmlFor='postal_address'>
                      Postal Address
                    </FormLabel>
                    <Input
                      type='text'
                      placeholder='E.g P.O Box 234'
                      name='postal_address'
                      ref={register}
                      defaultValue={profile.profile.postal_address}
                    ></Input>
                    <FormErrorMessage>
                      {errors.postal_address && errors.postal_address.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    mt='20px'
                    isInvalid={errors.residential_address}
                    flex='1'
                    w='50%'
                  >
                    <FormLabel htmlFor='residential_address'>
                      Residential Address
                    </FormLabel>
                    <Input
                      type='text'
                      placeholder='Residential Address'
                      name='residential_address'
                      ref={register}
                      defaultValue={profile.profile.residential_address}
                    ></Input>
                    <FormErrorMessage>
                      {errors.residential_address &&
                        errors.residential_address.message}
                    </FormErrorMessage>
                  </FormControl>
                </Flex>
                <Flex w='100%'>
                  <FormControl
                    mt='20px'
                    isInvalid={errors.region}
                    flex='1'
                    w='50%'
                  >
                    <FormLabel htmlFor='region'>Region</FormLabel>
                    <Select
                      type='text'
                      placeholder='Select Region'
                      name='region'
                      ref={register}
                      defaultValue={profile?.profile?.region}
                      onChange={(e) => handleSelectRegion(e.target.value)}
                    >
                      {regions.map((region) => {
                        return (
                          <option
                            value={region.value}
                            key={region.value}
                            // selected={profile.profile.region === region.value}
                          >
                            {region.label}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>
                      {errors.region && errors.region.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl w='50%' mt='20px' flex='1'>
                    <FormLabel htmlFor='city'>City</FormLabel>
                    <Select
                      type='text'
                      name='city'
                      ref={register}
                      defaultValue={profile?.profile?.city}
                      onChange={(e) => setSelectedDistrict(e.target.value)}
                    >
                      {districts.map((district) => {
                        return (
                          <option
                            value={district}
                            key={district}
                            // selected={profile?.profile?.city === district}
                          >
                            {district}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>
                      {errors.city && errors.city.message}
                    </FormErrorMessage>
                  </FormControl>
                </Flex>
              </Box>
              <Box flex='1' ml='15px' m='10px'>
                <Flex w='100%'>
                  <FormControl mt='20px' w='32%'>
                    <FormLabel>Sex</FormLabel>
                    <Select
                      ref={register}
                      name='gender'
                      defaultValue={profile.gender}
                    >
                      <option value='male'>Male</option>
                      <option value='female'>Female</option>
                      <option value='other'>Other</option>
                    </Select>
                  </FormControl>
                  <FormControl mt='20px' w='32%'>
                    <FormLabel htmlFor='phone'>Phone</FormLabel>
                    <Input
                      id='phone'
                      placeholder='+233 505-34-345'
                      name='phone_number'
                      ref={register}
                      defaultValue={profile.phone_number}
                    />
                  </FormControl>
                  <FormControl mt='20px' flex='1' w='32%' isRequired>
                    <FormLabel
                      htmlFor='date_of_birth'
                      isInvalid={errors.date_of_birth}
                    >
                      Date of Birth
                    </FormLabel>
                    <Input
                      type='date'
                      name='date_of_birth'
                      ref={register({ required: "Field is required" })}
                      defaultValue={getDate(profile.profile?.date_of_birth)}
                    ></Input>
                    <FormErrorMessage>
                      {errors.date_of_birth && errors.date_of_birth.message}
                    </FormErrorMessage>
                  </FormControl>
                </Flex>
              </Box>
            </Box>
            <FormControl
              flex='1'
              mt='20px'
              isInvalid={errors.languages}
              m='10px'
            >
              <FormLabel>Languages</FormLabel>
              <CheckboxGroup
                colorScheme='green'
                defaultValue={userSpokenLanguages}
                isInline
                spacing='6'
                name='languages'
                onChange={(values) => setLanguages(values)}
              >
                {langOptions.map((option, index) => (
                  <Checkbox value={option} key={index}>
                    {option}
                  </Checkbox>
                ))}
              </CheckboxGroup>
            </FormControl>
          </Flex>
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            flex='1'
            w='100%'
          >
            <Button
              type='submit'
              variantColor='green'
              color='white'
              size='md'
              height='48px'
              width={["100%", "200px"]}
              _focus='none'
              my='5'
              isLoading={formState.isSubmitting}
            >
              Update
            </Button>
            <Button
              bg='red.400'
              color='white'
              height='48px'
              width={["100%", "100px"]}
              _focus='none'
              my='5'
              ml='4'
              _hover={{ bg: "red.600" }}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default ProfileEditPage;
